import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Listar from '../../../../components/auth/licitacao/listar/encerradas'


function ListarLicEncerradasScreen() {

    return (
        <Fragment>
            <Head titulo="Licitações em Encerradas" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarLicEncerradasScreen;